// export { default as DefaultPage } from './DefaultPage';
export { default as BannerNav } from './BannerNav';
export { default as BannerNavMenu } from './BannerNavMenu';
export { default as Banner } from './Banner';
export { default as BannerBody } from './BannerBody';
export { default as HomeContent } from './HomeContent';
export { default as App } from './App';
// export { default as Agreement } from './Agreement';
export { default as ExperienceClass } from './ExperienceClass';



// WEBPACK FOOTER //
// ./src/features/home/index.js